/**
 * @generated SignedSource<<7ac85c0ecf7734d4eeab256aebae2ab8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentAdsContainer_boostedContentResource$data = {
  readonly __typename: string;
  readonly categories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly chorusId: number | null;
  readonly globalId: string;
  readonly id: string;
  readonly internalCategories?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly internalSuperCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly superCats?: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly " $fragmentType": "ContentAdsContainer_boostedContentResource";
};
export type ContentAdsContainer_boostedContentResource$key = {
  readonly " $data"?: ContentAdsContainer_boostedContentResource$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentAdsContainer_boostedContentResource">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "slug",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentAdsContainer_boostedContentResource",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chorusId",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CategoryResourceType",
          "kind": "LinkedField",
          "name": "categories",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalCategoryResourceType",
          "kind": "LinkedField",
          "name": "internalCategories",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SuperCatResourceType",
          "kind": "LinkedField",
          "name": "superCats",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalSuperCatResourceType",
          "kind": "LinkedField",
          "name": "internalSuperCats",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        }
      ],
      "type": "FeedContentResourceInterface",
      "abstractKey": "__isFeedContentResourceInterface"
    }
  ],
  "type": "ContentResourceInterface",
  "abstractKey": "__isContentResourceInterface"
};
})();

(node as any).hash = "13d421faf2240430c288782c53e2592e";

export default node;
